import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = ['Me encantó porque las rutinas son simples y realmente pude mantener el hábito.', 'Perfecto para entrenar desde casa sin complicarse.', 'Muy claro y práctico. Lo recomiendo.', 'Me ayudó a empezar a entrenar cuando no sabía por dónde comenzar.', 'En 2 semanas ya me sentía con más energía.', 'Lo mejor es que no necesitás nada para empezar.', 'Me cambió la cabeza con respecto al ejercicio.', 'Fácil de seguir y súper práctico.', 'Lo pude adaptar a mi rutina sin problema.', 'Por fin algo que puedo mantener.', 'Muy bueno para arrancar desde cero.', 'Vale totalmente la pena.'];
  return <section className="py-24 bg-rose-50" data-id="element-197">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-200">
            Lo que dicen quienes ya empezaron
          </h2>
          <div className="flex items-center justify-center gap-1 text-rose-500" data-id="element-201">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-202" />)}
          </div>
        </motion.div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-203">
          {testimonials.map((text, index) => <motion.div key={index} className="break-inside-avoid bg-white p-6 rounded-2xl shadow-sm border border-rose-100" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index % 3 * 0.1
        }} data-id="element-204">
              <div className="flex text-yellow-400 mb-3" data-id="element-205">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-206" />)}
              </div>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-207">
                "{text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}